import React, { useState, Fragment, useEffect } from 'react'

// Material-UI Core
import { makeStyles, withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import Hidden from '@material-ui/core/Hidden'
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser'
import TextField from '@material-ui/core/TextField';

import { Checkbox, FormLabel, FormGroup, FormControlLabel, FormControl } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";

// Material-UI Icon
import Domain from '@material-ui/icons/Domain'
import ExpandMore from '@material-ui/icons/ExpandMore'

// Custom Component
import { Alert } from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import { AppBarButton } from '../../styles/jss/components/button'

import { saveDefaultSite } from '../../dataSource/userModule.js'
// Custom Style
import iconStyle from '../../styles/jss/components/iconStyle'
import { Autocomplete } from '@material-ui/lab'

// Pil Details
import { getPILNature } from "../../dataSource/pil";
import { Check } from '@material-ui/icons'

const SiteTypography = withStyles({
	root: {
		fontSize: 16,
		fontWeight: 600,
		color: '#0000b3',
	},
})(Typography)

const SiteMenuItem = withStyles((theme) => ({
	root: {
		'&:focus': {
			backgroundColor: '#adc2eb',
			// '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
			// 	color: theme.palette.common.white,
			// },
		},
	},
}))(MenuItem)

const useStyles = makeStyles(iconStyle)

const SiteButton = (props) => {
	const classes = useStyles()
	const store = require('store')
	const { siteList } = props

	const [selectedSite, setSelectedSite] = useState(store.get('site_code'))
	const [anchorEl, setAnchorEl] = useState(null)

	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: '',
		title: '',
		content: '',
	})

	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: '',
		dialogContent: '',
		confirmAction: '',
		cancelAction: '',
	})

	// Build Alert
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content,
		})
		setAlertOpen(true)
	}

	// Build Confirm Dialog
	const confirmDialogHandleOpen = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction,
		})

		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}

	// Main Action
	const siteChangeConfirmAction = (event, siteSeq, siteCode) => {
		setAnchorEl(null)

		confirmDialogHandleOpen({
			dialogTitle: 'Site Change',
			dialogContent: 'Do you want to change the site.',
			confirmAction: () => handleMenuItemClick(event, siteSeq, siteCode),
			cancelAction: siteChangeCancelAction,
		})
	}

	const siteChangeCancelAction = () => {
		confirmDialogHandleClose()
	}


	const handleMenuClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleMenuClose = () => {
		setAnchorEl(null)
	}

	const handleMenuItemClick = (event, siteSeq, siteCode) => {
		store.set('site', siteSeq)
		store.set('site_code', siteCode)

		saveDefaultSite(siteSeq)
			.then(() => {
				setAnchorEl(null)
				siteChangeCancelAction()
				buildAlert({
					// Alert Type: success, info, warning, error
					type: 'success',
					title: 'Site Changed',
					content: 'The active site Change to ' + store.get('site_code'),
				})

				setTimeout(() => {
					window.location.reload()
				}, 1000)
			})
			.catch((err) => {
				buildAlert({
					// Alert Type: success, info, warning, error
					type: 'error',
					title: 'Unable to change site',
					content: 'Please contact IT for support.',
				})
			})
	}

	const [inputValue, setInputValue] = useState('');
	const [inputNature, setInputNature] = useState([]);

	const dispatch = useDispatch();

	const getPilNature = async () => {
		const response = await getPILNature();
		dispatch({
			type: "HANDLE_PIL_VALUE",
			data: response.data,
		});
		return response
	};

	useEffect(() => {
		getPilNature().then((result) => {
			setInputNature(result.data);
		});
	}, []);

	const siteCodeFilter = (inputValue) => {

		const siteNatureList = inputNature;

		let natureMap = [];

		const natures = {
			RESD: 'Residential',
			RET: 'Retail',
			OFF: 'Office',
			IND: 'Industrial',
			HOT: 'Hotel',
			DA: 'Data Centre',
			AA: "A&A Works",
			OTHERS: 'Others'
		}

		const inputValues = inputValue.split('|').map(value => value.trim());

		let natureCode = []
		let siteCode = []

		for (let inputValue of inputValues) {
			if (inputValue.length) {

				//1. search and get the nature code in the object

				// when the user inputs more than one natures
				if (inputValue.includes(' ')) {

					let multipleValue = inputValue.split(/\s+/);
					let multipleNaturesSet = new Set();

					for (let mV of multipleValue) {

						let checked = false;

						Object.entries(natures).forEach(([key, value]) => {
							if (value.toLowerCase().includes(mV.toLowerCase())) {
								multipleNaturesSet.add(key.toUpperCase());
								checked = true;
							}
						});

						//assume the inputValue is a A&Aworks item or Others item
						if (!checked) {
							natureCode.push(inputValue.toUpperCase())
						}

					}

					if (multipleNaturesSet) {
						natureCode.push([...multipleNaturesSet])
					}
				}
				// when the user inputs only one nature
				else {

					let checked = false;

					let keyFromFullname = ''
					Object.entries(natures).forEach(([key, value]) => {
						if (value.toLowerCase().includes(inputValue.toLowerCase())) {
							keyFromFullname = key;
							checked = true;
						}
					});

					if (keyFromFullname) {
						//we can find the natureCode from its fullname
						natureCode.push(keyFromFullname.toUpperCase())
					}

					//assume the inputValue is a A&Aworks item or Others item
					if (!checked) {
						natureCode.push(inputValue.toUpperCase())
					}
				}

				//also assume the input value may be a site code
				siteCode.push(inputValue.toUpperCase())
			}
		}

		let matchedNatureSite = [];

		// Iterate over each nature code and filter the siteNatureList based on the nature code
		for (let code of natureCode) {
			const isMatch = siteNatureList.filter(siteNature => {

				if (Array.isArray(code) && code.length) {
					return code.every(nV => siteNature.nature.join(" ").toUpperCase().includes(nV));
				} else {
					return siteNature.nature.join(" ").toUpperCase().includes(code);
				}
			});

			// Add the filtered results to the matchedNatureSite array
			matchedNatureSite.push(...isMatch);
		}

		// Extract the site codes from the matchedNatureSite array and add them to the siteCode array

		for (let matchedSite of matchedNatureSite) {
			siteCode.push(matchedSite.site_code)
		}

		let matchedSite = []

		// If siteList is not null, iterate over each site in the siteList and 
		// check if the site's fullname includes any of the site codes in the siteCode array

		if (siteList) {
			for (let site of siteList) {
				let fullname = (site.shortname + site.name).toUpperCase()

				for (let searchSite of siteCode) {
					if (fullname.includes(searchSite.toUpperCase())) {
						matchedSite.push(site);
					}
				}
			}
		}

		let result = []
		if (!inputValue.length) {
			result = siteList || []
		}

		if (matchedSite && matchedSite.length) {
			result = [...new Set(matchedSite)]
		}

		return (
			<div id="siteCodeMenu"
				style={{
					width: siteList
						? siteList.reduce((acc, curr) => {
							const combinedString = `${curr.name} | ${curr.shortname}`;
							return combinedString.length > acc.length
								? combinedString
								: acc;
						}, '').length * 10
						: 100,
				}}
			>
				{
					result !== null
						? result.map((item) => {
							return (
								<SiteMenuItem
									key={item.site_seq}
									selected={item.site_seq === store.get('site')}
									onClick={(event) =>
										siteChangeConfirmAction(event, item.site_seq, item.code)
									}
								>
									{item.pilUploaded === 'Y' && (
										<Tooltip title="Project Information List Uploaded">
											<VerifiedUserIcon
												color="primary"
												style={{ margin: '2px' }}
											/>
										</Tooltip>
									)}
									{item.shortname} | {item.name}
								</SiteMenuItem>
							)
						})
						: ''
				}
			</div>
		);

	}

	return (
		<Fragment>
			<Alert
				open={alertOpen}
				alertType={alertData.type}
				alertTitle={alertData.title}
				alertContent={alertData.content}
				handleClose={() => setAlertOpen(false)}
			/>

			<ConfirmDialog
				open={confirmDialogOpen}
				dialogTitle={confirmDialogData.dialogTitle}
				dialogContent={confirmDialogData.dialogContent}
				confirmAction={confirmDialogData.confirmAction}
				cancelAction={confirmDialogData.cancelAction}
			/>

			<div>
				<Hidden smDown>
					<Tooltip title="Change Site" aria-label="change_site">
						<AppBarButton
							onClick={handleMenuClick}
							startIcon={<Domain className={classes.iconProperties} />}
							endIcon={<ExpandMore className={classes.iconProperties} />}
						>
							<SiteTypography>{selectedSite}</SiteTypography>
						</AppBarButton>
					</Tooltip>
				</Hidden>

				<Hidden mdUp>
					<Tooltip title="Change Site" aria-label="change_site">
						<IconButton
							aria-controls="site-menu"
							aria-haspopup="true"
							onClick={handleMenuClick}
						>
							<Domain className={classes.iconProperties} />
						</IconButton>
					</Tooltip>
				</Hidden>

				<Menu
					id="site-menu"
					anchorEl={anchorEl}
					keepMounted
					getContentAnchorEl={null}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}
					open={Boolean(anchorEl)}
					onClose={handleMenuClose}
				>
					<TextField
						id="Search-bar"
						label=""
						variant="outlined"
						style={{
							width: '95%',
							margin: 10
						}}
						onChange={(event) => {
							setInputValue(event.target.value);
						}}
					/>

					{
						siteCodeFilter(inputValue)
					}

				</Menu>
			</div>
		</Fragment >
	)
}

//RET IND AA OFF HOT DA RESD OTHERS
//Residential Retail Office Industrial Hotel Data Centre A&A Works Others

// const SiteIcon = () => {
// 	const classes = useStyles()
// 	const store = require('store')
// 	// const {siteList} = props
// 	const [anchorEl, setAnchorEl] = React.useState(null)
// 	const [selectedSite, setSelectedSite] = useState(store.get('site_code'))

//     const handleClick = (event) => {
//         setAnchorEl(event.currentTarget)
//     }

//     const handleClose = () => {
//         setAnchorEl(null)
//     }

//     return (
//         <div>
//             <Tooltip title='Change Site' aria-label='change_site'>
//                 <IconButton aria-controls='site-menu' aria-haspopup='true' onClick={handleClick}>
//                     <Domain className={classes.iconProperties} />
//                 </IconButton>
//             </Tooltip>

//             <Menu
//                 id='site-menu'
//                 anchorEl={anchorEl}
//                 keepMounted
//                 getContentAnchorEl={null}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//                 transformOrigin={{ vertical: 'top', horizontal: 'center' }}
//                 open={Boolean(anchorEl)}
//                 onClose={handleClose}
//             >
//                 <MenuItem onClick={handleClose}>KTIL240</MenuItem>
//                 <MenuItem onClick={handleClose}>TPTL157</MenuItem>
//                 <MenuItem onClick={handleClose}>AFFC Extension</MenuItem>
//             </Menu>
//         </div>
//     )
// }

export default SiteButton
